import { apiClient } from "./index";
import { POST } from "./index";
import { AxiosResponse } from "axios";

// Response interface for PDF generation
export interface GeneratePDFResponse {
  status: "success" | "error";
  url?: string;
  message: string;
}

// Claim history item interface
export interface ClaimHistoryItem {
  suitId: string;
  name: string;
  brandImage: string;
  payout: number;
  dueAt: string;
  category: string;
  createdAt: string;
  mailedAt?: string;
  claimed: boolean;
}

// Response interface for claim history
export interface ClaimHistoryResponse {
  data: ClaimHistoryItem[];
}

/**
 * Generate a PDF for a claimed class action
 * @param claimId - The ID of the class action claim
 * @returns Promise with the PDF generation response
 */
export const generateClaimPDF = async (
  suitId: string
): Promise<GeneratePDFResponse> => {
  try {
    const response: AxiosResponse<GeneratePDFResponse> = await apiClient.post(
      "/claims/generate-pdf",
      { suitId },
      {
        timeout: 30000,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error generating PDF:", error);
    throw error;
  }
};

/**
 * Get user's claim history with suit data
 * @returns Promise with the claim history response
 */
export const getClaimHistory = async (): Promise<ClaimHistoryItem[]> => {
  try {
    const response = await POST<ClaimHistoryResponse>("/claim/history");
    if (response.success && response.data?.data) {
      return response.data.data;
    }
    return [];
  } catch (error) {
    console.error("Error fetching claim history:", error);
    return [];
  }
};
